import React from 'react';
import { ModalHeader, ModalBody, Modal } from 'reactstrap';
import StaticHtmlContent from "../../common/staticHtmlContent";

class VideoVisitTerms extends React.Component {
    constructor(props) {
        super(props);
        this.onModalOpened = this.onModalOpened.bind(this);
    }
    toggleModal = () => {
        this.props.toggleModal(false);
    }

    onModalOpened() {
        const { heading, terms } = this.props;
        const textContent = heading === "Complaint Notice and Privacy Practice" ? "NOTICE CONCERNING COMPLAINTS" :
            heading === "Patients' Rights" ? "PATIENT RIGHTS AND RESPONSIBILITIES" : "";
        if (textContent) {
            const xpath = `//h2[text()='${textContent}']`;
            const element = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
            if (element && element.scrollIntoView)
                element.scrollIntoView();
        }
    }

    render() {
        const { heading, showModal, terms } = this.props;
        return (
            <Modal isOpen={showModal} toggle={this.toggleModal} className="video-visit-terms" onOpened={this.onModalOpened}>
                <ModalHeader>{heading}
                    <button className="btn btn-icon-only" title="Close" aria-label="Close" onClick={() => this.toggleModal(false)}><span className="icon-close modal-header-close-btn" /></button>
                </ModalHeader>
                <ModalBody>
                    <StaticHtmlContent content={terms} />
                </ModalBody>                
            </Modal>
        );
    }
}
export default VideoVisitTerms;
